import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-brand-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="font-bold text-xl text-brand-900 mb-4">
              DR. GRASSL <span className="text-brand-600">&</span> Coll.
            </h3>
            <p className="text-brand-700 text-sm leading-relaxed">
              Geprüfter Sachverständiger & Rating Advisor (TÜV)
            </p>
            <p className="text-brand-700 text-sm mt-2">
              Bauschaden-Sachverständigenwesen, Immobilienbewertung und Investments
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-brand-900 mb-4">Kontakt</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3 text-brand-700">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <div className="text-sm">
                  <div>Bahnhofstraße 8</div>
                  <div>26316 Varel</div>
                </div>
              </div>
              <a
                href="mailto:hdgdr@icloud.com"
                className="flex items-center space-x-3 text-brand-700 hover:text-brand-900 transition-colors group"
              >
                <Mail size={18} className="flex-shrink-0" />
                <span className="text-sm group-hover:underline">hdgdr@icloud.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-brand-900 mb-4">Leistungen</h4>
            <ul className="space-y-2 text-sm text-brand-700">
              <li>Restnutzungsdauer</li>
              <li>Gutachten</li>
              <li>Investments</li>
              <li>Spezialgutachten</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-brand-600">
            © {new Date().getFullYear()} DR. GRASSL & Coll. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            <Link 
              to="/datenschutz" 
              className="text-sm text-brand-700 hover:text-brand-900 transition-colors hover:underline"
            >
              Datenschutz
            </Link>
            <Link 
              to="/impressum" 
              className="text-sm text-brand-700 hover:text-brand-900 transition-colors hover:underline"
            >
              Impressum
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
